import { Navigate } from 'react-router-dom';

export function UserLogoutPage() {
  localStorage.removeItem('user');

  return <Navigate to="/login" />;
}
